import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { Prescripteur } from 'src/app/shared/models/prescripteur';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { HttpParams } from '@angular/common/http';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';

@Injectable({
	providedIn: 'root'
})
export class PrescripteurService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	prescripteurIsyUrl = `https://pvyv02.isycare-technology.com/affectation/prescripteur/ocashe`;

	getAllPrescripteurs(): Observable<Prescripteur[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prescripteurUrl}/all`,
			'getAllPrescripteurs',
		);
	}

	/**
	 * Renvoi la liste de tout les prescripteurs avec le minimum d'information (id, nom, prénom, care skill)
	 * @returns liste de prescripteur
	 */
	getPrescripteursMinimal(): Observable<Prescripteur[]> {
		let queryParams = new HttpParams().append('light', true);
		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prescripteurUrl}`,
			'getPrescripteurs',
			httpOptions
		);
	}

	/**
	 * Renvoi la liste de tout les prescripteurs avec le minimum d'information (id, nom, prénom, care skill)
	 * @returns liste de prescripteur
	 */
	getPrescripteursPageable(
		page: number,
		size: number,
		search: string,
		skills: string
	): Observable<ListingResponse> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('page', page);
		queryParams = queryParams.append('size', size);
		if (search) {
			queryParams = queryParams.append('search', search);
		}
		if (skills) {
			queryParams = queryParams.append('skill', skills);
		}

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prescripteurUrl}/page`,
			'getPrescripteurs',
			httpOptions
		);
	}

	/**
	 * Renvoie un prescripteur en fonction de l'id transmie
	 * @param id id de l'utilisateur
	 * @returns prescripteur
	 */
	getPrescripteurById(id: number): Observable<Prescripteur> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prescripteurUrl}/get/${id}`,
			'getPrescripteurById'
		);
	}

	getPrescripteurByRegion(regionId: number): Observable<Prescripteur[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prescripteurUrl}/getByRegion/${regionId}`,
			'getByRegion'
		);
	}

	importPrescripteurs(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'prescripteurs.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.prescripteurUrl}/import`,
			`importPrescripteurs`,
			formData
		);
	}

	/**
	 * Met à jour un prescripteur
	 * @param prescripteur
	 * @returns
	 */
	updatePrescripteur(prescripteur: Prescripteur): Observable<string> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.prescripteurUrl}/update/${prescripteur.id}`,
			`updatePrescripteur`,
			prescripteur
		);
	}

	/**
	 * Sauvegarde un prescripteur
	 * @param prescripteur
	 * @returns
	 */
	addPrescripteur(prescripteur: Prescripteur): Observable<number> {
		console.log(prescripteur);
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.prescripteurUrl}/add`,
			`addPrescripteur`,
			prescripteur
		);
	}

	/**
	 * Supprime un prescripteur
	 * @param prescripteurId
	 * @returns
	 */
	deletePrescripteur(prescripteurId: number): Observable<string> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.prescripteurUrl}/delete/${prescripteurId}`,
			`deletePrescripteur`
		);
	}

	addPrescripteurIsy(prescripteur: Prescripteur): Observable<number> {
		return this.genericCrudService.genericPostDataToAPI(
					`${this.prescripteurIsyUrl}/post`,
					`addPrescripteurIsy`,
					prescripteur
				);
		
	}

	updatePrescripteurIsy(prescripteur: Prescripteur): Observable<string> {
		return this.genericCrudService.genericPostDataToAPI(
					`${this.prescripteurIsyUrl}/put`,
					`updatePrescripteurIsy`,
					prescripteur
				);
		
	}

	deletePrescripteurIsy(prescripteurId: number): Observable<string> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.prescripteurIsyUrl}/delete/${prescripteurId}`,
			`deletePrescripteur`
		);
	}
}
